<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderSearchSubmit)="onSearchLab($event)"
    (onHeaderInputKeyup)="onSearchInputKeyup($event)"
  ></page-header-search>
  <div class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="col-7">
          <app-page-header-selections class="mb-0" 
            [headerSelections]="['All', 'Lab Test', 'Scan']" 
            title="All Labs" (pageChanged)="changePageId($event)">
          </app-page-header-selections>
        </div>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div *ngIf="filteredLabs?.length" class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredLabs" [routerLink]="['tests', item.id]">
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.arName }}</span>
              </td>
              <td>
                <span>{{
                  item.centerTypeId == 1
                    ? "Lab"
                    : item.centerTypeId == 2
                    ? "Scan"
                    : item.centerTypeId == 3
                    ? "Test & Scan"
                    : ""
                }}</span>
              </td>
              <td>
                <span>{{ item.phone }}</span>
              </td>
              <td>
                <span>{{ item.email }}</span>
              </td>
              <td>
                <span>{{ item.countryId == 1 ? 'Egypt' : '' }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default" (click)="$event.stopPropagation()">
                    <input
                      [checked]="item.isActive"
                      type="checkbox"
                      id="active-check"
                      (change)="onLabActiveChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-info mr-2"
                  type="button"
                  placement="top"
                  tooltip="Branches"
                  [routerLink]="['/branches/', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-books"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-default mr-2"
                  type="button"
                  placement="top"
                  tooltip="Fees"
                  [routerLink]="['homeFeesList', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-shopping-bag"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteLab($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
